import * as React from 'react'

const SvgComponent = props => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12.73 7.78' {...props}>
    <path d='M6.36 2.83 1.41 7.78 0 6.37 6.36 0l6.36 6.36-1.41 1.41-4.95-4.94Z' />
  </svg>
)

export default SvgComponent
